import { LinearProgress } from "@material-ui/core";
import React from "react";
import {
	EditButton,
	List as RaList,
	TextField,
} from "react-admin";
import StatusField from "../bookmaker-channels/fields/StatusField";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles } from "../components/lists/useStyles";
import useNetwork from "../useNetwork";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import CopyLinkButton from "./CopyLinkButton";
import { ChannelsBulkActions } from "./CopyLinksButton";
import LandingField from "./fields/LandingField";
import Filters from "./Filters";

const List = (props) => {
	const classes = useListStyles();
	const { loading, network } = useNetwork();
	if (loading) {
		return <LinearProgress />;
	}
	return (
		<RaList
			{...props}
			actions={<Actions />}
			filters={<Filters />}
			sort={{ field: "modified", order: "DESC" }}
			perPage={perPage()}
			classes={classes}
			title="resources.channels.name"
			bulkActionButtons={<ChannelsBulkActions network={network} />}
		>
			<ResponsiveList
				mobileHeader={
					<React.Fragment>
						<TextField
							source="name"
							style={{ fontWeight: "bold" }}
							variant="h6"
						/>
						<EditButton />
					</React.Fragment>
				}
				mobileBody={
					<React.Fragment>
						<TextField
							source="bookmaker.name"
							label="resources.bookmaker-channels.fields.bookmaker.name"
							style={{ fontWeight: "bold" }}
							variant="overline"
						/>
						<LandingField
							source="landing"
							variant="caption"
							color="textSecondary"
							sortable={false}
						/>
					</React.Fragment>
				}
				mobileActions={
					<React.Fragment>
						<StatusField source="status" admin={false} />
						<CopyLinkButton
							network={network}
							source="hash"
							label=""
							sortable={false}
						/>
					</React.Fragment>
				}
			>
				<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
				<TextField
					source="bookmaker.name"
					label="resources.bookmaker-channels.fields.bookmaker.name"
					sortBy="Bookmakers.name"
					style={{
						fontWeight: "bold",
					}}
				/>
				<TextField source="name" variant="overline" />
				<LandingField source="landing" sortable={false} variant="overline" />
				<StatusField source="status" admin={false} sortable={false} />
				<CopyLinkButton
					network={network}
					source="hash"
					label=""
					sortable={false}
				/>
				<EditButton />
			</ResponsiveList>
		</RaList>
	);
};
export default List;
